import { ComponentChildren } from 'preact'
import styles from './index.module.css'
import okSvg from './ok.svg'
import { useRef, useEffect } from 'react'
import { Container, Transition } from 'semantic-ui-react'
import { classnames } from '../../../utils'

export const ToastMessage = ({
  children,
  show,
  timeout = 1000,
  onFinishedTimeout,
}: {
  children: ComponentChildren
  show: boolean
  timeout: number
  onFinishedTimeout: () => void
}) => {
  const timerID = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => {
    return () => timerID.current && clearTimeout(timerID.current)
  }, [])

  const startCountDown = () => {
    timerID.current && clearTimeout(timerID.current)
    timerID.current = setTimeout(() => {
      onFinishedTimeout()
    }, timeout)
  }

  return (
    <Transition
      animation={'fade up'}
      duration={300}
      visible={show}
      onShow={() => {
        startCountDown()
      }}
    >
      <div
        class={classnames(styles.toast, styles.bottom)}
        onClick={() => {
          timerID.current && clearTimeout(timerID.current)
          onFinishedTimeout()
        }}
      >
        <img src={okSvg} alt="" />
        <span class={styles.text}>{children}</span>
      </div>
    </Transition>
  )
}
